import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useBranding } from '../../../contexts/BrandingContext';
import CompanyContext from '../../../contexts/CompanyContext';
import { footerCompanyName } from '../../../utils/footerCompanyName';

/**
 * AppFooter - Shared footer component for all layouts
 *
 * Features:
 * - Copyright uses the occupancy company-name SoT (LYN-331)
 * - Privacy Policy link
 * - Terms & Conditions link
 * - Submit a Bug link (opens external form in new tab)
 *
 * @notes
 * - CP occupancy: channel_partners.name (public organizationName)
 * - SO occupancy: sales_organizations.organization_name
 * - No occupancy: companies.business_name
 * - Never identity.tagline or identity.platformName
 */
const AppFooter = () => {
  const { occupancy, organizationName } = useBranding();
  const companyCtx = useContext(CompanyContext);
  const companyName = footerCompanyName({
    occupancy,
    organizationName,
    businessName: companyCtx?.company?.businessName || companyCtx?.company?.business_name
  });
  const year = new Date().getFullYear();
  const copyright = companyName
    ? `© ${year} ${companyName}. All rights reserved.`
    : `© ${year}. All rights reserved.`;

  return (
    <footer className="bg-gray-900 text-gray-400 py-4 mt-auto border-t border-gray-800 overscroll-none">
      <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2 sm:gap-0">
        <div className="flex-1 min-w-0 px-8">
          <div className="text-sm">
            {copyright}
          </div>
        </div>
        <div className="flex items-center flex-wrap gap-x-6 gap-y-1 text-sm px-8">
          <Link to="/privacy" className="hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-white transition-colors">
            Terms & Conditions
          </Link>
          <a
            href="https://forms.clickup.com/9009203324/f/8cfv23w-174/LBKFO0BV554PV6GZVN"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Submit a Bug
          </a>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
